// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3KzOT","footer":"ModalFilter_footer__16ags"};